import React, { InputHTMLAttributes, useState } from 'react';

import { EyeIcon } from '../../icons';
import { CommonInput } from '../index';

import './InputPassword.scoped.scss';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  password: string;
  onInput: (password: any) => void;
  title: string;
  id: string;
}

const InputPassword = ({ password, onInput, title, id, ...props }: Props) => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    setVisible((visible) => !visible);
  };

  const EyeExtension = (
    <div onClick={toggleVisible} className="input-password__toggle">
      <EyeIcon
        title="Toggle password visibility"
        color={visible ? 'var(--primary-green-new)' : '#222222'}
      />
    </div>
  );

  return (
    <CommonInput
      value={password}
      onChange={onInput}
      title={title}
      type={visible ? 'text' : 'password'}
      extensions={[EyeExtension]}
      className="input-password"
      id={id}
      {...props}
    />
  );
};

export default InputPassword;
